import React, { useEffect, useState } from 'react'
import { useTheme, useMediaQuery, Grid } from '@material-ui/core'
import InviteInformation from './InviteInformation'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { creatorInfoSelector } from '../redux/selectors'
import queryString from 'query-string'


const RegistrationPagesWrapper = ({
    children,
    creatorInfo,
    showCreatorInfoPanel = false
}) => {
	const theme = useTheme()
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'), {
		defaultMatches: true
    })


    return (
        <Grid
            container
            justifyContent="center"
            style={{
                marginTop: '10vh',
                paddingBottom: '10vh'
            }}
        >
            <Grid
                item
                xs={11}
                sm={9}
                md={4}
                xl={3}
                style={{
                    marginRight: isMobile ? '0' : '25px', 
                    minWidth: isMobile ? '0' : '500px'
                }}
            >
                {children}
            </Grid>
            {
                !isMobile
                && !!showCreatorInfoPanel
                && <Grid
                    item
                    md={4}
                    lg={3}
                    xl={2}
                >
                    <InviteInformation creatorInfo={creatorInfo} />
                </Grid>
            }
        </Grid>
    )
}

const mapStateToProps = (state, ownProps) => ({
    creatorInfo: creatorInfoSelector(state)
})

const mapDispatchToProps = (dispatch, ownProps) => ({})

const enhance = compose(
    connect(mapStateToProps, mapDispatchToProps)
)

export default enhance(RegistrationPagesWrapper)
